import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class MarketingCampaignData extends EntityData<MarketingCampaignData> {
    @identifier id: number;
    @field name: string;
}
